import { render, staticRenderFns } from "./BaseSupporters.vue?vue&type=template&id=4e07f14b&scoped=true&"
import script from "./BaseSupporters.vue?vue&type=script&lang=js&"
export * from "./BaseSupporters.vue?vue&type=script&lang=js&"
import style0 from "./BaseSupporters.vue?vue&type=style&index=0&id=4e07f14b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e07f14b",
  null
  
)

export default component.exports